import React from "react";
import { Box, Container, Text, SimpleGrid, Flex } from "@chakra-ui/react";
import { motion } from "framer-motion";
import { BookOpen } from "lucide-react";

const MotionBox = motion(Box);

const books = [
  { title: "Gray's Anatomy", sub: "Anatomy" },
  { title: "Ross & Wilson", sub: "Anatomy & Physiology" },
  { title: "Kozier & Erb's", sub: "Fundamentals of Nursing" },
  { title: "Harrison's Principles", sub: "Internal Medicine" },
  { title: "Robbins Pathology", sub: "Pathology" },
];

export const Benefits = () => {
  return (
    <Box bg="#FFFFFF" py={{ base: "64px", md: "96px" }}>
      <Container maxW="1200px" px={{ base: "5", md: "8" }}>

        <Flex direction="column" align="center" textAlign="center" mb={{ base: 12, md: 16 }}>
          <Text
            fontFamily="'Inter', sans-serif"
            fontSize="0.8125rem"
            fontWeight="600"
            letterSpacing="0.1em"
            textTransform="uppercase"
            color="#0095C8"
            mb={3}
          >
            Credibility
          </Text>
          <Text
            as="h2"
            fontFamily="'Public Sans', sans-serif"
            fontWeight="600"
            fontSize={{ base: "1.75rem", md: "2.375rem" }}
            color="#293452"
            lineHeight="1.25"
            maxW="640px"
            mb={4}
          >
            Built on the books that shape{" "}
            <Box as="span" color="#0095C8">real clinical understanding</Box>
          </Text>
          <Text
            fontFamily="'Inter', sans-serif"
            fontSize={{ base: "0.9375rem", md: "1.0625rem" }}
            color="rgba(41,52,82,0.6)"
            maxW="480px"
            lineHeight="1.7"
          >
            Every guide is grounded in standard reference texts.
          </Text>
        </Flex>

        <SimpleGrid columns={{ base: 1, sm: 2, lg: 3 }} spacing={5} mb={10}>
          {books.map((book, i) => (
            <MotionBox
              key={book.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: i * 0.08 }}
            >
              <Box
                p={6}
                bg="white"
                border="1px solid rgba(0,149,200,0.1)"
                borderTop="3px solid"
                borderTopColor="#0095C8"
                borderRadius="12px"
                boxShadow="0 2px 12px rgba(41,52,82,0.06)"
                h="full"
                cursor="default"
                _hover={{
                  transform: "translateY(-4px)",
                  boxShadow: "0 8px 32px rgba(41,52,82,0.12)",
                }}
                transition="all 0.3s cubic-bezier(0.4,0,0.2,1)"
              >
                <Box
                  w="40px"
                  h="40px"
                  borderRadius="10px"
                  bg="#E9FFFF"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  mb={4}
                >
                  <BookOpen size={18} color="#0095C8" strokeWidth={1.75} />
                </Box>
                <Text
                  fontFamily="'Public Sans', sans-serif"
                  fontWeight="600"
                  fontSize="1.0625rem"
                  color="#293452"
                  mb={1}
                  lineHeight="1.3"
                >
                  {book.title}
                </Text>
                <Text
                  fontFamily="'Inter', sans-serif"
                  fontSize="0.875rem"
                  color="rgba(41,52,82,0.55)"
                >
                  {book.sub}
                </Text>
              </Box>
            </MotionBox>
          ))}
        </SimpleGrid>

        <Flex justify="center">
          <Text
            fontFamily="'Inter', sans-serif"
            fontSize={{ base: "0.9375rem", md: "1.0625rem" }}
            color="rgba(41,52,82,0.6)"
            maxW="560px"
            textAlign="center"
            lineHeight="1.7"
          >
            Then{" "}
            <Box as="span" color="#293452" fontWeight="600">
              simplified, structured, and focused
            </Box>{" "}
            — for how nursing students actually study and get tested.
          </Text>
        </Flex>

      </Container>
    </Box>
  );
};
